import { mergeDeepRight } from 'ramda';
var defaultState = {
  type: 'default',
  footer: {
    closeButton: {
      type: 'close',
      enabled: false
    },
    prevButton: {
      enabled: true
    }
  }
};
export function prepareLayoutConfiguration(preloadedState) {
  if (!preloadedState || !preloadedState.layoutConfiguration) {
    return defaultState;
  }
  return mergeDeepRight(defaultState, preloadedState.layoutConfiguration);
}